import React from 'react';

export const AlertCircleInfo = () => (
    <>
        <circle cx='12' cy='12' r='9' />
        <line x1='12' y1='8' x2='12.01' y2='8' />
        <polyline points='11 12 12 12 12 16 13 16' />
    </>
);